import axios from "../../../axios/index.js"
import state from "../../../../store/state";

// Token Refresh
let domain = state.domain; // se hizo este proceso porque index.jx no puede leer el proceso de store.

export default {
  loadGeneral(id_usuario, cod_persona,estado) {
  return  axios.post(domain+`mapgrafi/estudiante/student-load-general`, {id_usuario: id_usuario, cod_persona: cod_persona,estado:estado,cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
    cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO});
  },
  insertUpdate(request) {
    return  axios.post(domain+`mapgrafi/estudiante/student-insert-update`, 
      {
        evento: request['evento'], 
        id_usuario: request['id_usuario'],
        id_usuario_estudiante : request['id_usuario_estudiante'],
        numero_identificacion : (_.isEmpty(request['numero_identificacion'])) ? null : request['numero_identificacion'],
        estado: (request['evento'] == "I") ? null : 'I',
        cod_empresa:process.env.VUE_APP_COD_EMPRESA_ERP,
        cod_empresa_aca:process.env.VUE_APP_COD_EMPRESA_ACADEMICO
      });
  }
}